import { colors } from "../../../common/styles";

const { blue, green, red, yellow, white, darkYellow } = colors;

export default (theme) => ({
    avatar: {
        textTransform: "capitalize",
        background: green,
        color: white
    },
    assetApproved: {
        background: green
    },
    assetSeen: {
        background: green
    },
    addedNewEvidence: {
        background: darkYellow
    },
    addedNewImage: {
        background: yellow
    },
    assetComment: {
        background: blue
    },
    assetRejected: {
        background: red
    },
    assetExcluded: {
        background: red
    }
});
